var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToggleOff24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 25,
    viewBox: "0 0 47 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 0H13C5.92864 0 0 6.10417 0 13C0 19.8958 5.92864 25 13 25H34C41.0714 25 47 19.8958 47 13C47 6.10417 41.0714 0 34 0ZM34 21H12C7.33444 21 4 17.6963 4 13C4 8.30375 7.33444 4 12 4H34C38.6656 4 42 8.30375 42 13C42 17.6963 38.6656 21 34 21ZM6 13C6 9.40333 9.40333 6 13 6C16.5967 6 19 9.40333 19 13C19 16.5967 16.5967 19 13 19C9.40333 19 6 16.5967 6 13Z",
    fill: "#FE8083"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOff24Px);
export default __webpack_public_path__ + "static/media/toggle_off_24px.19079c5edcb54080a0f08bf2c1857f84.svg";
export { ForwardRef as ReactComponent };